import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { HpSharedHeroCarousel } from './HpSharedHeroCarousel';

import { type HpSharedHeroModule_viewer$key } from './__generated__/HpSharedHeroModule_viewer.graphql';
import { type HpSharedHeroModule_user$key } from './__generated__/HpSharedHeroModule_user.graphql';
import { type HpSharedHeroModule_componentModule$key } from './__generated__/HpSharedHeroModule_componentModule.graphql';

const viewerFragment = graphql`
    fragment HpSharedHeroModule_viewer on Viewer {
        ...HpSharedHeroCarousel_viewer @include(if: $isClient)
    }
`;

const userFragment = graphql`
    fragment HpSharedHeroModule_user on User {
        ...HpSharedHeroCarousel_user
    }
`;

const componentModuleFragment = graphql`
    fragment HpSharedHeroModule_componentModule on HeroModule {
        ...HpSharedHeroCarousel_componentModule
    }
`;

export const HpSharedHeroModule: FC<{
    viewer: HpSharedHeroModule_viewer$key;
    user?: HpSharedHeroModule_user$key | null;
    componentModule: HpSharedHeroModule_componentModule$key;
    isMobile: boolean;
    isClient?: boolean;
}> = ({
    viewer: viewerRef,
    user: userRef,
    componentModule: componentModuleRef,
    isMobile,
    isClient,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);
    const componentModule = useFragment(componentModuleFragment, componentModuleRef);

    return (
        <HpSharedHeroCarousel
            viewer={isClient ? viewer : null}
            user={user}
            componentModule={componentModule}
            isMobile={isMobile}
        />
    );
};
